export function prepareTranslatedData(dataTranslated: any, date: Date): Map<string, any> {
    const translatedMap = new Map<string, any>();

    for (const entry of dataTranslated) {
        const created = new Date(entry.created);

        if (created >= date) continue;

        const existing = translatedMap.get(entry.i18n_id);

        if (!existing || created > new Date(existing.created)) {
            translatedMap.set(entry.i18n_id, entry);
        }
    }

    return translatedMap;
}